module.exports = __webpack_public_path__ + "static/media/SocialPiper-socialmeadia-easy-header.84220953.jpg";